module.exports = __webpack_public_path__ + "static/media/Paola_Lizbeth_Angeles_Pacheco_2.e4f90b0c.png";